import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

type SummaryItem = {
  label: string;
  value: React.ReactNode;
  className?: string;
};

type SummarySection = {
  title?: string;
  items: SummaryItem[];
};

type Props = {
  title: string;
  sections: SummarySection[];
  className?: string;
};

export const SummaryCard: React.FC<Props> = ({
  title,
  sections,
  className,
}) => {
  return (
    <Card className={cn('bg-card', className)}>
      <CardContent className="p-4 space-y-4">
        {/* Main Title */}
        <h4 className="text-sm font-medium text-foreground tracking-tight border-b pb-2">
          {title}
        </h4>

        {sections.map((section, idx) => (
          <div key={idx} className="space-y-2">
            {section.title && (
              <div className="text-xs uppercase text-muted-foreground font-semibold mt-2">
                {section.title}
              </div>
            )}

            {/* Rows */}
            <div className="space-y-1">
              {section.items.map((item, i) => (
                <div key={i} className="flex justify-between text-sm py-1">
                  <span className="text-muted-foreground">{item.label}</span>
                  <span
                    className={cn(
                      'font-medium text-right ml-4',
                      item.className,
                    )}
                  >
                    {item.value || (
                      <span className="text-muted-foreground italic">
                        Not set
                      </span>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
